import { useCurrentTripContext } from '../hooks/useCurrentTripContext'
import { useAuthContext } from '../hooks/useAuthContext'

const TripAccomodation = ({trip, accomodations, onAddAccomodation, onEditAccomodation}) => {
    const { dispatch } = useCurrentTripContext()
    const { user } = useAuthContext()

    const handleClick = async (e, accomodation) => {
        e.preventDefault()
        e.stopPropagation()
        if (!user) {
            return
        }
        
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/accomodation/`, {
            method: 'DELETE',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({trip_id: trip._id, accomodation_id: accomodation._id}),
            credentials: 'include'
        })
        const json = await response.json()
        if (response.ok) {
            dispatch({type: 'DELETE_ACCOMODATION', payload: json})
        }
    }

    return (
        <div className="accomodation-page">
            <h3>Accommodation:</h3>
            <button onClick={() => onAddAccomodation("add")}>Add Accommodation</button>
            <div className="accomodations-list">
                {accomodations?.map((accomodation) => (
                    <div key={accomodation._id} className="accomodation-card" onClick={(e) => {
                        onEditAccomodation(accomodation)
                        onAddAccomodation("edit")
                    }}>
                        <p><strong>{accomodation.accomodation_name}</strong></p>
                        <p><strong>Address: </strong>{accomodation.accomodation_address}</p>
                        <p><strong>Link For Accomodation: </strong><a href={accomodation.accomodation_link} target="_blank" rel="noreferrer">Click Here</a></p>
                        <div className="checkin-checkout-details">
                            <p><strong>Check-in: </strong>{accomodation.checkin_date} at {accomodation.checkin_time}</p>
                            <p><strong>Check-out: </strong>{accomodation.checkout_date} at {accomodation.checkout_time}</p>
                        </div>
                        <p><strong>Additional Details: </strong>{accomodation.additional_details}</p>
                        <span className="material-symbols-outlined" onClick={(e) => {handleClick(e, accomodation)}}>delete</span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default TripAccomodation

